import { useEffect, useState } from 'react';
import { getSfeduConnection, getSfeduStatus, startSfeduSignIn } from '../../api/auth';
import sfeduLogo from '../../assets/icons/sfedu-white.svg';
import './SfeduSignIn.css';

export function SfeduSignIn({ link = false, primary = false, onAvailability }) {
  const [enabled, setEnabled] = useState(false);
  const [linked, setLinked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    (async () => {
      const status = await getSfeduStatus();
      if (!active) return;
      onAvailability?.(Boolean(status?.enabled));
      if (!status?.enabled) return;
      const connection = link ? await getSfeduConnection() : null;
      if (active) {
        setEnabled(true);
        setLinked(Boolean(connection?.linked));
      }
    })().catch(() => { if (active) onAvailability?.(false); });
    return () => { active = false; };
  }, [link, onAvailability]);

  if (!enabled) return null;

  const start = async () => {
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      const result = await startSfeduSignIn(link);
      if (!result?.authorization_url) throw new Error('Не удалось начать вход. Попробуйте ещё раз.');
      window.location.assign(result.authorization_url);
    } catch (err) {
      setError(err.message || 'Не удалось открыть вход ЮФУ. Попробуйте ещё раз.');
      setBusy(false);
    }
  };

  return <div className={`sfedu-sign-in${primary ? ' sfedu-sign-in-primary' : ''}`}>
    {linked ? <p className="sfedu-sign-in-connected" role="status">Учётная запись ЮФУ подключена</p> :
      <button className="sfedu-sign-in-button" type="button" onClick={start} disabled={busy} aria-busy={busy}>
        <img className="sfedu-sign-in-mark" src={sfeduLogo} alt="" aria-hidden="true" />
        <span className="sfedu-sign-in-label">
          <span className="sfedu-sign-in-title">
            {busy ? 'Открываем вход ЮФУ…' : link ? 'Подключить учётную запись ЮФУ' : 'Войти через ЮФУ'}
          </span>
          <span className="sfedu-sign-in-subtitle">Единая учётная запись университета</span>
        </span>
        <svg className="sfedu-sign-in-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>}
    <p className="sfedu-sign-in-hint">{link
      ? 'После подключения можно входить с учётной записью университета. Команды, баллы и история сохранятся.'
      : primary
        ? 'Впервые здесь? Создадим аккаунт. Уже есть профиль с этой почтой? Поможем подключить ЮФУ и сохранить ваши данные.'
        : 'Впервые на ЮФУ.Про? Создадим аккаунт при входе через ЮФУ.'}</p>
    {error && <p className="sfedu-sign-in-error" role="alert">{error}</p>}
  </div>;
}
